import { render } from "./LeadsTab.vue?vue&type=template&id=15ebfd0b&scoped=true"
import script from "./LeadsTab.vue?vue&type=script&lang=js"
export * from "./LeadsTab.vue?vue&type=script&lang=js"

import "./LeadsTab.vue?vue&type=style&index=0&id=15ebfd0b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ebfd0b"]])

export default __exports__